import { Loader2 } from "lucide-react";
import { Progress } from "@/shared/ui/progress";
import { useTranslation } from "@/shared/i18n";

import type { SaveStep } from "../model";

interface Props {
  step: SaveStep;
  open: boolean;
}

export function SaveProgress({ step, open }: Props) {
  const { t } = useTranslation("psdTemplates");

  if (!open || step.phase === "idle" || step.phase === "done") return null;

  let label = "";
  let percent = 0;

  if (step.phase === "creating") {
    label = t("save.creating");
    percent = 10;
  } else if (step.phase === "uploading") {
    label = t("save.uploading", {
      current: step.current,
      total: step.total,
      file: step.fileName,
    });
    percent = step.total > 0 ? 10 + (step.current / step.total) * 80 : 50;
  } else if (step.phase === "saving") {
    label = t("save.saving");
    percent = 95;
  }

  return (
    <div className="fixed inset-0 z-50 bg-background/60 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-card border rounded-xl shadow-xl p-6 w-full max-w-md space-y-4">
        <div className="flex items-center gap-3">
          <Loader2 className="w-5 h-5 animate-spin text-primary" />
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-foreground">{t("save.title")}</h3>
            <p className="text-sm text-muted-foreground truncate">{label}</p>
          </div>
        </div>
        <Progress value={percent} />
      </div>
    </div>
  );
}
